import { useState } from 'react';
import { BizButton } from '../../../Core/Components/Mini/BizButton';
import {
	useGetDriverLogs,
	useDeleteDriverLog,
	useSubmitDriverLog,
} from '../../../Core/Hooks/useTravelReport';
import { DriverLog } from '../../../Core/Types/admin/timereport';
import DriverLogForm from './DriverLogForm';
import './DriverLogMain.scss';

const getStatusText = (item: DriverLog): string => {
	if (item.isAttested) return 'Attested';
	if (item.isSubmitted) return 'Submitted';
	return 'Draft';
};

const getStatusClass = (item: DriverLog): string => {
	if (item.isAttested) return 'attested';
	if (item.isSubmitted) return 'submitted';
	return 'draft';
};

const DriverLogMain = () => {
	const { driverLogs, statusState } = useGetDriverLogs();
	const { remove } = useDeleteDriverLog();
	const { submit, statusState: submitStatus } = useSubmitDriverLog();
	const [showForm, setShowForm] = useState(false);
	const [editingLog, setEditingLog] = useState<DriverLog | null>(null);

	const handleEdit = (log: DriverLog) => {
		setEditingLog(log);
		setShowForm(true);
	};

	const handleNewLog = () => {
		setEditingLog(null);
		setShowForm(true);
	};

	const handleFormClose = () => {
		setShowForm(false);
		setEditingLog(null);
	};

	return (
		<div className='biz-driver-log-main'>
			<h3>Driver Log</h3>

			<div className='biz-driver-log-main__actions'>
				<BizButton text='New Driver Log' onClick={handleNewLog} icon='fa-solid fa-plus' />
			</div>

			{statusState === 'LOADING' && <p>Loading...</p>}

			{(!driverLogs || driverLogs.length === 0) && statusState === 'SUCCESS' && (
				<div className='biz-driver-log-main__empty'>No driver logs found.</div>
			)}

			{driverLogs && driverLogs.length > 0 && (
				<table className='biz-driver-log-main__table'>
					<thead>
						<tr>
							<th>Period</th>
							<th>License Number</th>
							<th>Mileage In</th>
							<th>Mileage Out</th>
							<th>Total</th>
							<th>Status</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{driverLogs.map((log) => (
							<tr key={log.id} onClick={() => handleEdit(log)}>
								<td>{log.period.split('T')[0]}</td>
								<td>{log.licenseNumber}</td>
								<td>{log.mileageIn}</td>
								<td>{log.mileageOut}</td>
								<td>{log.mileageOut - log.mileageIn}</td>
								<td>
									<span
										className={`biz-driver-log-main__status-badge biz-driver-log-main__status-badge--${getStatusClass(log)}`}
									>
										{getStatusText(log)}
									</span>
								</td>
								<td>
									{!log.isSubmitted && (
										<>
											<BizButton
												text='Submit'
												onClick={(e: React.MouseEvent) => {
													e.stopPropagation();
													submit(log.id);
												}}
												state={submitStatus}
											/>
											<BizButton
												text='Delete'
												onClick={(e: React.MouseEvent) => {
													e.stopPropagation();
													remove(log.id);
												}}
											/>
										</>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			)}

			{showForm && (
				<DriverLogForm existingLog={editingLog} onClose={handleFormClose} />
			)}
		</div>
	);
};

export default DriverLogMain;
